export default __webpack_public_path__ + "static/media/integrated-database.7cf34bd7.png";